import React from 'react';
import PropTypes from 'prop-types';
import {Tabs} from '@learningblocks/storybook-components';
import {ExperimentOutcomes} from './ExperimentOutcomes';

import './style.scss';
import {Techniques} from './Techniques';

const TAB = {
  EXPERIMENT_OUTCOMES: 'EXPERIMENT_OUTCOMES',
  TECHNIQUES: 'TECHNIQUES',
};

/**
 * TechniqueOptionTabPane:
 *  - TabPane display options in the notebook in design section.
 *    The pane display a expeimental outcomes and techniques card of the techniques section in design view
 *    User can select a tab to more between different view and select options
 */
export function TechniqueOption(props) {
  console.log('test', props);

  const onTabClicked = (tab) => props.onTabSelect(tab);
  const className = `techniqueOptionTabView ${props.className}`;
  const renderTabHeading = () => (
    <Tabs.List className='techniqueOptionTabView_menuList'>
      <Tabs.Menu
        className='techniqueOptionTabView_menuList--menu'
        onClick={onTabClicked}
        value={TAB.TECHNIQUES}
        key='1'>
        Techniques
      </Tabs.Menu>
      <Tabs.Menu
        className='techniqueOptionTabView_menuList--menu'
        onClick={onTabClicked}
        value={TAB.EXPERIMENT_OUTCOMES}
        key='0'>
        Experimental outcomes
      </Tabs.Menu>
    </Tabs.List>
  );

  return (
    <Tabs.Tabs className={className} default={props.current}>
      {renderTabHeading()}
      <Tabs.Panel
        key='0'
        menuValue={TAB.TECHNIQUES}
        className='techniqueOptionTabView_tabContent'>
        <Techniques list={props.options[0].list} onSelect={props.onSetStep} />
      </Tabs.Panel>
      <Tabs.Panel
        key='1'
        menuValue={TAB.EXPERIMENT_OUTCOMES}
        className='techniqueOptionTabView_tabContent'>
        <ExperimentOutcomes
          list={props.options[1].list}
          onSelect={props.onSetStep}
        />
      </Tabs.Panel>
    </Tabs.Tabs>
  );
}

TechniqueOption.propTypes = {
  /**
   * Titile of the Toggle tab component
   */
  title: PropTypes.string.isRequired,
  /**
   * style to recive from out of the component
   */
  className: PropTypes.string,
  /**
   * is it StepsView or TechniquesView that is displayed below is set using currentView
   */
  current: PropTypes.oneOf(['EXPERIMENT_OUTCOMES', 'TECHNIQUES']).isRequired,
  /**
   * Function to invoke when a Tab is Selected
   */
  onTabSelect: PropTypes.func.isRequired,
  /**
   * List of options
   */
  options: PropTypes.arrayOf(
    /**
     * first object is list for Technique and second one for Outcome
     */
    PropTypes.shape({
      list: PropTypes.arrayOf( 
        PropTypes.shape({
          /**
           * id number of the each component
           */
          id: PropTypes.number,
          /**
           * card type
           */
          type: PropTypes.string,
          /**
           * title of card
           */
          title: PropTypes.string,
          /**
           * image file path
           */
          image: PropTypes.string,
          /**
           * visibility of card
           */
          visible: PropTypes.bool,
          /**
           * description to be displayed in card
           */
          description: PropTypes.string,
        })
      ),
    })
  ),
};

TechniqueOption.defaultProps = {
  title: '',
  techniqueList: [],
  experimentOutcomesList: [],
};
